import styled from '@emotion/native';
import { Authentication } from 'core/auth';

const Background = styled.View(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.color['base-grey'],
}));

export default function Login() {
  return (
    <Background>
      <Authentication />
    </Background>
  );
}
